import { Link } from 'react-router-dom'
import PelviaLogo from './PelviaLogo'
import { signInUrl } from '@/lib/auth'

export default function SiteFooter() {
  return (
    <footer className="border-t border-white/[0.06] bg-black px-8 py-10">
      <div className="mx-auto flex max-w-[1100px] flex-col flex-wrap items-center justify-between gap-4 sm:flex-row">
        <div className="flex items-center gap-2">
          <PelviaLogo size={28} animation="none" style={{ opacity: 0.5 }} />
          <span className="text-[0.82rem] text-white/35">Pelvia.me</span>
        </div>
        <div className="flex flex-wrap justify-center gap-6 sm:gap-8">
          <Link to="/pelviacare" className="text-[0.82rem] text-white/35 no-underline transition-colors hover:text-white/70">
            PelviaCare+
          </Link>
          <Link to="/endometriosis" className="text-[0.82rem] text-white/35 no-underline transition-colors hover:text-white/70">
            Learn
          </Link>
          <Link to="/privacy" className="text-[0.82rem] text-white/35 no-underline transition-colors hover:text-white/70">
            Privacy
          </Link>
          <Link to="/terms" className="text-[0.82rem] text-white/35 no-underline transition-colors hover:text-white/70">
            Terms
          </Link>
          <Link to="/contact" className="text-[0.82rem] text-white/35 no-underline transition-colors hover:text-white/70">
            Contact
          </Link>
          <a href={signInUrl()} className="text-[0.82rem] text-white/35 no-underline transition-colors hover:text-white/70">
            Sign in
          </a>
        </div>
      </div>
    </footer>
  )
}
